<template>
  <div id="demo-basic-card">
    <heading style-size="h4" size="h1" class="mb-5">Available Experiences</heading>
    <div role="list" class="vx-row">
      <div
        role="listitem"
        class="vx-col w-full sm:w-1/3 xl:w-1/4 mb-base"
        v-for="item in available_experiences"
        :key="item.id"
      >
        <vx-card :custom-classes="['h-100']">
          <div slot="no-body">
            <img
              :src="item.main_image | blob_url"
              role="presentation"
              class="responsive card-img-top"
              alt=""
            />
          </div>
          <span v-if="item.is_external" class="badge badge-primary">External</span>
          <heading style-size="h5" size="h2" class="mb-3">{{ item.name }}</heading>
          <p class="text-grey hidden">{{ item.description }}</p>

          <div
            class="cta flex flex-wrap mt-5 pt-5"
            :class="{ 'justify-between': !!item.video_url, 'justify-end': !item.video_url }"
          >
            <button
              v-if="!!item.video_url"
              :id="`watch-intro-button-${item.id}`"
              class="btn btn-secondary btn-size-small"
              :aria-label="`Watch intro - ${item.name}`"
              @click="openVideoPopup(item.video_url, `watch-intro-button-${item.id}`)"
            >
              <div class="flex">
                <span class="mr-2">Watch intro</span>
                <feather-icon
                  aria-hidden="true"
                  class="mr-0 cursor-pointer menu-ctrl"
                  icon="PlayCircleIcon"
                  svg-classes="stroke-width-1 text-gray-400 h-4 w-4"
                  @click="toggleReduce(!reduce)"
                />
              </div>
            </button>
            <button
              class="btn btn-primary btn-size-small"
              role="link"
              :aria-label="`${isStarted(item.id) ? 'Continue' : 'Start'} ${item.name} experience`"
              @click="startExperience(item.id)"
            >
              {{ isStarted(item.id) ? 'Continue' : 'Start' }}
            </button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';

export default {
  components: {},
  computed: {
    settings() {
      return store.getters['authStudent/settings'];
    },
    available_experiences() {
      return store.getters['authStudent/available_experiences'].filter((e) => !e.is_external);
    },
    experiences() {
      return store.getters['authStudent/experiences'];
    },
  },
  data() {
    return {
      name: localStorage.getItem('fname') + ' ' + localStorage.getItem('lname'),
    };
  },
  methods: {
    openVideoPopup(videoCode, buttonId) {
      if (videoCode.includes('youtube.com')) {
        store.dispatch('popup/showIframePopup', videoCode);
      } else {
        store.dispatch('popup/showVideoPopup', videoCode);
      }
      store.commit('popup/setFocusElemOnPopupClose', buttonId);
    },
    startExperienceConfirm(itemID) {
      /*if(false && !this.preworkCompleted) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Error',
          text: 'Please complete the prework sections before starting a job experience.'
        })
      }
      else {*/
      const experience = this.available_experiences.find((i) => i.id == itemID);

      const vm = this;

      let title = `Start Work Experience?`;
      let color = 'primary';
      let text = 'Are you sure you want to start the ' + experience.name + ' Work Experience?';
      if (store.getters['authStudent/activeExperienceID']) {
        title = 'You already have an active Work Experience';
        color = 'danger';
        text =
          'Are you sure you want to start the ' +
          experience.name +
          ' Work Experience? This will cancel the existing Work Experience and start the new one.';
      }
      this.$vs.dialog({
        type: 'confirm',
        color: color,
        title: title,
        text: text,
        accept: async function () {
          await vm.startExperience(itemID);
        },
      });
      //}
    },
    async startExperience(itemID) {
      let existed = this.experiences.find((experience) => experience.vje_id === itemID);

      if (existed) {
        store.commit('authStudent/setActiveExperienceID', existed.id);
        router.push('/student/work-experience-router');
      } else {
        store.dispatch('authStudent/startExperience', itemID);
      }
    },
    isStarted(id) {
      return this.experiences.findIndex((experience) => experience.vje_id === id) !== -1;
    },
  },
  mounted() {
    if (
      typeof this.settings['work_experience'] !== 'undefined' &&
      this.settings['work_experience'] == false
    ) {
      router.push('/student/dashboard');
    }
  },
};
</script>

<style lang="scss">
.vx-card__body {
  h2 {
    min-height: 48px;
  }

  .badge {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #a2d7bf;
    color: #000;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 0.8em;
  }
}
</style>
